import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-170b41c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import PopUp from "@/lib/components/popup/PopUp.vue";
  import {defaultPopUpsInstanceIds} from "@/lib/store/manager/popup/PopUpsStoreManager";

  interface UserManualElement {
    title: string
    content: string
  }

  
export default /*#__PURE__*/_defineComponent({
  name: 'UserManual',
  props: {
    userManualElements: null
  },
  setup(__props: any) {

  

  const instanceId: string = defaultPopUpsInstanceIds.userManual;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      _createVNode(PopUp, {
        title: "Controls",
        "popup-class": "user-manual",
        "default-instance-id": _unref(instanceId)
      }, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userManualElements, (element, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", null, _toDisplayString(element.title), 1),
                _createElementVNode("td", {
                  innerHTML: element.content
                }, null, 8, _hoisted_1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["default-instance-id"])
    ]),
    _: 1
  }))
}
}

})